import {useContext, useEffect, useState, useRef} from 'react';
import {ContentContext} from '../../Providers/ContentProvider';

import './AutoComplete.scss';

const AutoComplete = (props) => {
    const { namespaces, clientName } = useContext(ContentContext);
    const [searchQuery, setSearchQuery] = useState("");

    const autocompleteInput = useRef(null);

    useEffect(() => {
        autocomplete(document.getElementById("autocomplete-namespace"));   
    },[]);

    const handleChange = (e) => {
        if(e.target.value.length >= 2){
            autocomplete(document.getElementById("autocomplete-namespace"));
        }
        setSearchQuery(e.target.value);
    };

    const autocomplete = (inp) => {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        let currentFocus;
         /*execute a function when someone writes in the text field:*/
        inp.addEventListener("paste", function(e) {
             console.log("pasted")
            var a, b, i, val = autocompleteInput.current.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            if (!val) { return false;}
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", autocompleteInput.current.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/
            autocompleteInput.current.parentNode.appendChild(a);
            /*for each item in the array...*/
            for (i = 0; i < namespaces.length; i++) {
              /*check if the item starts with the same letters as the text field value:*/
              if (namespaces[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = "<strong>" + namespaces[i].substr(0, val.length) + "</strong>";
                b.innerHTML += namespaces[i].substr(val.length);
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + namespaces[i] + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {
                        setSearchQuery(e.target.innerText)
                        // self.setState({
                        //     [type] : e.target.innerText // autocompleteInput.current.getElementsByTagName("input")[0].value
                        // })
                        /*insert the value for the autocomplete text field:*/
                        inp.value = e.target.innerText //autocompleteInput.current.getElementsByTagName("input")[0].value;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                a.appendChild(b);
              } 
              else if (namespaces[i].toUpperCase().indexOf( val.toUpperCase()) > -1 && val.length > 3) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = namespaces[i].substr(0, namespaces[i].toUpperCase().indexOf( val.toUpperCase()));
                b.innerHTML += "<strong>" + namespaces[i].substr(namespaces[i].toUpperCase().indexOf( val.toUpperCase()), val.length) + "</strong>";
                b.innerHTML += namespaces[i].substr(namespaces[i].toUpperCase().indexOf( val.toUpperCase()) + val.length,namespaces[i].length );
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + namespaces[i] + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {
                        setSearchQuery(e.target.innerText)
                        // self.setState({
                        //     [type] : e.target.innerText // autocompleteInput.current.getElementsByTagName("input")[0].value
                        // })
                        /*insert the value for the autocomplete text field:*/
                        inp.value = e.target.innerText //autocompleteInput.current.getElementsByTagName("input")[0].value;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                a.appendChild(b);
              }
            }
        });
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function(e) {
            var a, b, i, val = autocompleteInput.current.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            if (!val) { return false;}
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", autocompleteInput.current.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/
            autocompleteInput.current.parentNode.appendChild(a);
            /*for each item in the array...*/
            for (i = 0; i < namespaces.length; i++) {
              /*check if the item starts with the same letters as the text field value:*/
              if (namespaces[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = "<strong>" + namespaces[i].substr(0, val.length) + "</strong>";
                b.innerHTML += namespaces[i].substr(val.length);
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + namespaces[i] + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {
                        setSearchQuery(e.target.innerText)
                        // self.setState({
                        //     [type] : e.target.innerText // autocompleteInput.current.getElementsByTagName("input")[0].value
                        // })
                        /*insert the value for the autocomplete text field:*/
                        inp.value = e.target.innerText //autocompleteInput.current.getElementsByTagName("input")[0].value;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                a.appendChild(b);
              } 
              else if (namespaces[i].toUpperCase().indexOf( val.toUpperCase()) > -1 && val.length > 3) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = namespaces[i].substr(0, namespaces[i].toUpperCase().indexOf( val.toUpperCase()));
                b.innerHTML += "<strong>" + namespaces[i].substr(namespaces[i].toUpperCase().indexOf( val.toUpperCase()), val.length) + "</strong>";
                b.innerHTML += namespaces[i].substr(namespaces[i].toUpperCase().indexOf( val.toUpperCase()) + val.length,namespaces[i].length );
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + namespaces[i] + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {
                        setSearchQuery(e.target.innerText)
                        // self.setState({
                        //     [type] : e.target.innerText // autocompleteInput.current.getElementsByTagName("input")[0].value
                        // })
                        /*insert the value for the autocomplete text field:*/
                        inp.value = e.target.innerText //autocompleteInput.current.getElementsByTagName("input")[0].value;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                a.appendChild(b);
              }
            }
        });
         /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function(e) {
            var x = document.getElementById("autocomplete-namespaceautocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode === 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
            } else if (e.keyCode === 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
            } else if (e.keyCode === 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
            }
            }
        });
        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            /*start by removing the "active" class on all items:*/
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            /*add class "autocomplete-active":*/
            if(x[currentFocus] !== undefined){
                removeActive(x);
                x[currentFocus].classList.add("autocomplete-active");
                return
            }
        }
        function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }
    
        function closeAllLists(elmnt) {
          /*close all autocomplete lists in the document,
          except the one passed as an argument:*/
          var x = document.getElementsByClassName("autocomplete-items");
          for (var i = 0; i < x.length; i++) {
            if (elmnt !== x[i] && elmnt !== inp) {
            x[i].parentNode.removeChild(x[i]);
          }
        }
      }
    };

    const checkNamespace = () => {
        let isActiveNamespace = namespaces.includes(searchQuery);
        if(isActiveNamespace){
            props.submit(searchQuery);
        }
    };

    return (
        <form autoComplete="off" id="auto-complete">
            <div className="autocomplete" style={{width: "100%"}}>
                <input id="autocomplete-namespace" ref={autocompleteInput} className="form-control search-input" value={searchQuery} type="text" name="Namespace" placeholder="namespace..." onChange={(e) => handleChange(e)} />
                <button className="btn btn-primary form-control search-input-btn" onClick={(e) => { e.preventDefault(); checkNamespace(); }} data-track="true" name="clientname-search">Go</button>
            </div>
        </form>
    );
}

export default AutoComplete;


